import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const SvgComponent = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <rect
        xmlns="http://www.w3.org/2000/svg"
        x="0.333333"
        y="0.333333"
        width="23.3333"
        height="23.3333"
        rx="1"
        fill="white"
      />
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M7.41944 9.90171L7.41944 9.90171C6.32618 10.9678 4.5479 10.9678 3.45481 9.90171C2.92517 9.38518 2.63325 8.69807 2.63325 7.9672C2.63327 7.23632 2.92517 6.5492 3.45483 6.03268L6.81318 2.75716L6.81319 2.75715C6.89703 2.67542 7.00682 2.63463 7.11633 2.63463C7.22582 2.63463 7.33561 2.67536 7.41946 2.75716C7.41946 2.75716 7.41946 2.75716 7.41946 2.75716L7.41944 9.90171ZM7.41944 9.90171L10.7779 6.62622C11.5629 5.8606 11.5628 4.61458 10.7778 3.84901C10.3854 3.46631 9.87028 3.27512 9.35526 3.27517C8.84038 3.27522 8.32498 3.46635 7.93264 3.84901L4.85414 6.85154C4.62352 7.07643 4.49627 7.3758 4.49623 7.69422C4.49623 8.01267 4.62343 8.31202 4.85409 8.53698C5.33003 9.00111 6.10401 9.00109 6.57984 8.5369C6.57984 8.5369 6.57984 8.5369 6.57985 8.53689L8.59307 6.57346C8.76104 6.40965 8.76104 6.14368 8.59311 5.97984C8.42561 5.81642 8.15435 5.81649 7.98683 5.97983L8.0101 6.0037L7.41944 9.90171Z"
        fill="#55585E"
        stroke="#55585E"
        strokeWidth="0.0666667"
      />
      <rect
        xmlns="http://www.w3.org/2000/svg"
        x="2.66675"
        y="14.668"
        width="18.6667"
        height="1.33333"
        fill="#BCBEC2"
      />
      <rect
        xmlns="http://www.w3.org/2000/svg"
        x="2.66675"
        y="17.3359"
        width="18.6667"
        height="1.33333"
        fill="#BCBEC2"
      />
      <rect
        xmlns="http://www.w3.org/2000/svg"
        x="2.66675"
        y="20"
        width="10.6667"
        height="1.33333"
        fill="#BCBEC2"
      />
      <rect
        xmlns="http://www.w3.org/2000/svg"
        x="0.333333"
        y="0.333333"
        width="23.3333"
        height="23.3333"
        rx="1"
        stroke="#D5D7DD"
        strokeWidth="0.666667"
      />
    </svg>
  </span>
);

export default SvgComponent;
